export default {
 pageTitle: 'ODI Overseas Investment Filing',
 heroTag: 'Overseas Investment Filing Service',
 heroDesc: 'Professional ODI overseas investment filing services to help enterprises legally conduct overseas investment and escort your global expansion',
 emailConsultation: 'Email Consultation',
 learnProcess: 'Learn the Process',
 whatIsTitle: 'What is ODI Overseas Investment Filing?',
 whatIsPara1: 'ODI (Outbound Direct Investment) filing refers to the act of Chinese domestic enterprises directly or through their controlled overseas enterprises establishing non-financial enterprises abroad or obtaining ownership, control, and management rights of existing non-financial enterprises through new construction, mergers and acquisitions.',
 whatIsPara2: 'According to relevant Chinese laws and regulations, before conducting overseas investment, enterprises need to complete filing or approval procedures with commerce departments, NDRC, and foreign exchange administration, ensuring investment compliance.',
 whatIsPara3: 'We provide one-stop ODI filing services to help enterprises successfully complete all approval procedures, making your overseas investment journey smooth.',
 whyNeedTitle: 'Why Need ODI Filing?',
 whyNeedSubtitle: 'Essential Conditions for Compliant Overseas Investment',
 reason1Title: 'Legal Compliance',
 reason1Desc: 'Meet national foreign exchange management and overseas investment management requirements, avoid compliance risks',
 reason2Title: 'Capital Outflow',
 reason2Desc: 'Obtain approval from foreign exchange authorities to legally handle cross-border remittance of investment funds',
 reason3Title: 'Tax Benefits',
 reason3Desc: 'Enjoy tax preferential policies related to overseas investment, reduce corporate tax costs',
 reason4Title: 'Corporate Reputation',
 reason4Desc: 'Enhance corporate international image and strengthen confidence of overseas partners',
 scopeTitle: 'Our Service Scope',
 scopeSubtitle: 'Full-process Professional Services to Ensure Successful Filing',
 scope1Title: 'Pre-consultation and Assessment',
 scope1Item1: 'Investment project feasibility analysis',
 scope1Item2: 'Investment destination selection advice',
 scope1Item3: 'Investment structure design and optimization',
 scope1Item4: 'Filing condition assessment and risk analysis',
 scope2Title: 'Filing Application Services',
 scope2Item1: 'NDRC overseas investment project filing',
 scope2Item2: 'Commerce department overseas investment filing',
 scope2Item3: 'Foreign exchange administration registration',
 scope2Item4: 'Bank account opening and capital outflow assistance',
 scope3Title: 'Document Preparation and Review',
 scope3Item1: 'Filing application document preparation',
 scope3Item2: 'Due diligence report writing',
 scope3Item3: 'Investment plan compilation',
 scope3Item4: 'Document translation and notarization',
 scope4Title: 'Follow-up Service Support',
 scope4Item1: 'Annual reports and change filing',
 scope4Item2: 'Overseas enterprise operation guidance',
 scope4Item3: 'Tax planning and compliance consulting',
 scope4Item4: 'Continuous compliance monitoring and reminders',
 processTitle: 'ODI Filing Process',
 processSubtitle: 'Clear and Transparent Processing Steps, Keep You Informed Throughout',
 step1Title: 'Initial Consultation',
 step1Desc: 'Understand client investment needs, assess project feasibility, formulate preliminary plan',
 step2Title: 'Document Preparation',
 step2Desc: 'Guide clients to prepare required documents for filing, including company files, investment plans, etc.',
 step3Title: 'NDRC Filing',
 step3Desc: 'Submit overseas investment project filing application to provincial NDRC, obtain project filing notice',
 step4Title: 'Commerce Department Filing',
 step4Desc: 'Apply for enterprise overseas investment certificate (ODI certificate) to provincial commerce department',
 step5Title: 'Foreign Exchange Registration',
 step5Desc: 'Process overseas direct investment foreign exchange registration at foreign exchange administration',
 step6Title: 'Capital Outflow',
 step6Desc: 'Assist in handling investment fund remittance procedures, complete overseas investment establishment',
 step7Title: 'Follow-up Services',
 step7Desc: 'Provide continuous compliance services such as annual reports and change filings',
 requirementsTitle: 'Basic Filing Requirements',
 requirementsSubtitle: 'Meeting These Conditions Makes Filing Approval Easier',
 companyRequirementsTitle: 'Enterprise Conditions',
 companyReq1: 'Domestic enterprise established for more than 1 year',
 companyReq2: 'Latest annual independent audit report shows profitability',
 companyReq3: 'Return on net assets not less than 5%',
 companyReq4: 'No major illegal or non-compliant records',
 companyReq5: 'Possess corresponding investment strength and management capabilities',
 projectRequirementsTitle: 'Investment Project Conditions',
 projectReq1: 'Comply with national overseas investment policy guidance',
 projectReq2: 'Not belong to restricted or prohibited investment projects',
 projectReq3: 'Stable policies in the investment destination country',
 projectReq4: 'Investment amount matches enterprise strength',
 projectReq5: 'Have clear business purposes and investment plans',
 noticeTitle: 'Important Notes',
 notice1: 'Investment in sensitive countries and regions requires special approval (e.g., involving national security, military, etc.)',
 notice2: 'Industries such as real estate, hotels, cinemas, entertainment, and sports clubs are strictly regulated',
 notice3: 'Investment amounts exceeding certain standards require NDRC approval rather than filing',
 notice4: 'Need to ensure investment fund sources are legal and compliant',
 ctaTitle: 'Professional ODI Filing Services, Empowering Your Global Expansion',
 ctaDesc: 'Over 20 years of professional experience, successfully assisted hundreds of enterprises in completing ODI filing, making your overseas investment journey smoother',
 viewMoreServices: 'View More Services',
}
